import { liteClient } from 'algoliasearch/lite'

const ALGOLIA_APP_ID = process.env.Q9GPIDDV0Q ?? ''
const ALGOLIA_API_KEY = process.env.d0e3e76d18b9a715e5fcaab2846c6c5a ?? ''

export const searchClient =
  ALGOLIA_APP_ID && ALGOLIA_API_KEY
    ? liteClient(ALGOLIA_APP_ID, ALGOLIA_API_KEY)
    : undefined
